export default function headerToTitle(items: string[]) {
    return items.join(' > ');
}
